import React, { createContext, useContext } from "react";
import { PrivyProvider } from "@privy-io/react-auth";

const PrivyAvailabilityContext = createContext(false);

/**
 * Privy's browser SDK is optional. Bank-funded transfers and local development
 * continue to work when no public Privy application ID is configured.
 *
 * Descendants that call Privy hooks (usePrivy, useFiatOnramp, etc.) must
 * check usePrivyAvailable() first — those hooks throw outside a
 * PrivyProvider, and no PrivyProvider is mounted when no app ID is set.
 */
export function PrivyProviderGate({ children }) {
  const appId = process.env.REACT_APP_PRIVY_APP_ID?.trim();

  if (!appId) {
    return (
      <PrivyAvailabilityContext.Provider value={false}>
        {children}
      </PrivyAvailabilityContext.Provider>
    );
  }

  return (
    <PrivyAvailabilityContext.Provider value={true}>
      <PrivyProvider
        appId={appId}
        config={{
          loginMethods: ["email", "google"],
          appearance: {
            theme: "light",
            accentColor: "#0A4730",
          },
          embeddedWallets: {
            createOnLogin: "off",
          },
        }}
      >
        {children}
      </PrivyProvider>
    </PrivyAvailabilityContext.Provider>
  );
}

export function usePrivyAvailable() {
  return useContext(PrivyAvailabilityContext);
}